import { BASE_ENDPOINT } from "../../endpoint";

export const downloadMigrationMastersheetService = async (
	token: string
): Promise<Blob> => {
	try {
		const response = await fetch(
			`${BASE_ENDPOINT}/migration/download-mastersheet`,
			{
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
					Accept:
						"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				},
			}
		);
		if (!response.ok) {
			console.error("Failed to download migration mastersheet");
			throw new Error("Failed to download migration mastersheet");
		}
		const blob = await response.blob();
		return blob;
	} catch (error) {
		console.error("API fetch error:", error);
		throw error;
	}
};
